<template>
  <el-card>
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="主题:" >
        <el-input v-model="searchFactor.theme" style="width:150px"></el-input>
      </el-form-item>
      <el-form-item label="团队:" >
        <el-select v-model="searchFactor.deptId" style="width:150px" placeholder="请选择">
          <el-option
            v-for="item in searchFactor.deptOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名:" >
        <el-input v-model="searchFactor.usrName" style="width:150px"></el-input>
      </el-form-item>
      <el-form-item label="姓名:" >
        <el-input v-model="searchFactor.fullName" style="width:150px"></el-input>
      </el-form-item>
      <el-form-item label="签名状态:" >
        <el-select style="width:100px"  v-model="searchFactor.signState" >
          <el-option label="全部" value=""></el-option>
          <el-option label="未签名" value="1"></el-option>
          <el-option label="已签名" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      ref="multipleTable"
      :highlight-current-row ="false"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="theme"
        label="主题"
        min-width="120px" >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="120px">
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="发布者"
        min-width="100px">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="120px">
      </el-table-column>
      <el-table-column
        prop="sendTime"
        label="发布时间"
        min-width="120px">
      </el-table-column>
      <el-table-column
          label="签名者"
          min-width="100px"  :formatter= "formatUserName">
        </el-table-column>
        <el-table-column
          prop="deptName"
          label="团队"
          min-width="100px" >
        </el-table-column>
        <el-table-column min-width="200px" prop="picture" label="签名">
        <template slot-scope="scope">
          <img v-if = "scope.row.signImage != null && scope.row.signImage!=''" :src="scope.row.signImage" fit="fill"  height="70"/>
        </template>
        </el-table-column>
        <el-table-column
        prop="signTime"
        label="签名时间"
        min-width="120px">
      </el-table-column>
        <el-table-column
          prop="usrState"
          label="签名状态"
          min-width="60px">
          <template slot-scope="scope">
            <span v-if = "scope.row.signImage == null ||  scope.row.signImage==''" style="color: rgb(245, 57, 15)">未签名</span>
            <span v-else style="color: rgb(47, 255, 82)" > 已签名</span>
          </template>
        </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" v-if = "scope.row.signImage != null && scope.row.signImage != ''" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"downLoad",index:scope.$index, data:scope.row}'><i class="el-icon-download" style="color:rgb(43, 255, 0)"></i> <span>下载</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"print",index:scope.$index, data:scope.row}'><i class="el-icon-printer " style="color:rgb(41, 10, 239)" ></i> <span>打印</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin:10px"
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :current-page="pager.curPage"
      :total="pager.totalCount" >
    </el-pagination>

    <!-- <el-dialog :visible.sync="dialogVisual.safeBook" fullscreen  v-on:close ="clearSafeBook">
      <div v-if = "safeBook.safeBookImage == null || safeBook.safeBookImage == ''" class = "w-e-text-container" ref="canvasDom" style="width:1000px;margin:auto">
        <div>
          <el-image :src = "logo2" style="width:300px; height: 55px;margin:20px">
          </el-image>
          <el-divider ></el-divider>
          <div data-slate-editor style="overflow:auto !important; width:1000px;height: 1100px;" v-html="safeBook.content">
          </div>
          <div style=" text-align: right; margin-top: 10px;" >
            <el-image :src ="safeBook.fileUrl" fit ="cover" :width= "150" :height="250"> 
            </el-image>
          </div>
        </div>
      </div>
      <div v-else style="width:1000px; margin:auto" id ="safeBookImage">
        <img :src = "safeBook.safeBookImage"  style="margin:20px;width:1000px; max-height: 1500px"/> 
      </div>
    </el-dialog>  -->


    <el-dialog :visible.sync="dialogVisual.safeBook" fullscreen  v-on:close ="clearSafeBook">
      <div v-if = "safeBook.safeBookImage == null || safeBook.safeBookImage == ''" class = "w-e-text-container" ref="canvasDom" style="width:1000px;margin:auto">
        <div>
          <el-image :src = "logo2" style="width:300px; height: 55px; margin:20px">
          </el-image>
          <el-divider ></el-divider>
          <div data-slate-editor style="overflow:auto !important; margin: auto; width:1000px;height: 1200px;" v-html="safeBook.content">
          </div>
          <div style="text-align: right; margin-top: 10px; margin-right: 20px;">
            <div style="height:60px;display: flex; margin-left: 60%; ">
              <span>责任人:</span> 
              <el-image :src ="safeBook.fileUrl" fit ="cover" :width= "30" :height="10"> 
              </el-image>
            </div>
            <div style="height:30px;display: flex; margin-left: 60%; ">
              <span>签名日期:</span> 
              <span> {{safeBook.signTime }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="margin:auto;width:1000px;" id ="safeBookImage">
        <img :src = "safeBook.safeBookImage"  style="margin:20px;width:1000px; max-height: 1520px"/> 
      </div>
    </el-dialog> 
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import logo2 from "@/assets/image/logo2.jpg"
import html2canvas from 'html2canvas'
import {PAGE_SIZE,MESSAGE_DURATION} from  '@/api/constant'
export default {
    name : 'pc_ctr_safe_book_search',
    data() {
    return {
      logo2,
      searchFactor: {
        theme: '',
        deptId : '',
        fullName :'',
        usrName :'',
        signState :'',
        deptOptions : []
      },
      dialogVisual:{
        safeBook : false
      },
      safeBook : {
        signTime :'',
        content :'',
        fileUrl :'',
        safeBookImage :''
      },
      tableData: [],
      pager:{
        curPage:0,
        totalCount:0,
        pageSize : PAGE_SIZE
      },
    }
  },

  methods : {
    handleCommand(command){
      let index = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'downLoad' :
          this.saveSafeBook(index,row)
          break
        case 'print' :
        this.printSafeBook(index,row)
        break
      }
    },
    // seeOneStudentSign(index,row){
    //   //this.handleViewNotice(index,row)
    //   // this.handleEditNotice(index,row)
    //   let left0 =  (window.screen.availWidth-10-1000)/2
    //   let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
    //   width=1000,height=1000,left=${left0},top=100`;
    //   window.open(SERVICE_URL+"/#/pc_ctr_editor_view/" +row.id +'_' +row.userId  +"?fileType=" + fileType.SAFE_BOOK,"安全责任书签名",params0);
    // },
    formatUserName(row, index){
       if( row.fullName == null || row.fullName == ''){

        return ""
       }
       return   row.fullName +"("+  row.usrName +")"
    },
    clearSafeBook(){
      this.safeBook.content = ''
      this.safeBook.fileUrl  = '',
      this.safeBook.safeBookImage = ''
      this.safeBook.signTime = ''
    },
    formatUserExamTime(row, index){
      let res = ''
      if(row.beginExamTime == null || row.beginExamTime == ''){

        return res
      }
      if(row.commitExamTime == null || row.commitExamTime == ''){

        return row.beginExamTime +"/?"
      }

      return   row.beginExamTime +"/"+  row.endTime

    },
    printSafeBook(index,item){
      this.dialogVisual.safeBook = true
      this.safeBook.content = item.content
      this.safeBook.fileUrl = item.signImage
      this.safeBook.signTime = item.signTime
      setTimeout(()=>{ 
      const canvasDom = this.$refs.canvasDom
      html2canvas(canvasDom, {
          dpi: 300, // 解决生产图片模糊
          useCORS: true,
          allowTaint: false,
          logging: false,
          scale: 2,
          windowHeight: 1000
        }).then((canvas) => {
          this.safeBook.safeBookImage = canvas.toDataURL('image/png')
          setTimeout(()=>{
            const content = document.getElementById('safeBookImage').innerHTML
            var newWindow = window.open('', '打印窗口');
            newWindow.document.write('<html><head><title>安全责任书</title></head><body>' + content + '</body></html>');
            newWindow.document.close();
            newWindow.print();
            newWindow.close();
          },200)
        }).catch((e) => {
          this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        })},300)
    },
    saveSafeBook(index,item){
      this.dialogVisual.safeBook = true
      this.safeBook.content = item.content
      this.safeBook.fileUrl = item.signImage
      this.safeBook.signTime = item.signTime
      setTimeout(()=>{ 
      const canvasDom = this.$refs.canvasDom
      html2canvas(canvasDom, {
          dpi: 300, // 解决生产图片模糊
          useCORS: true,
          allowTaint: false,
          logging: false,
          scale: 2,
          windowHeight: 1000
        }).then((canvas) => {
            this.safeBook.safeBookImage = canvas.toDataURL('image/png')
            let a = document.createElement("a");
            document.body.appendChild(a)
            a.setAttribute("download", `安全责任书_${item.theme}.png`);
            a.setAttribute("href", this.safeBook.safeBookImage);
            a.click();
            document.body.removeChild(a)
        }).catch((e) => {
          this.$message({
            showClose: true,
            message: e,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })},300)
    },
    onSearch(){
      this.safeBookListLoad(1)
    },
    safeBookListLoad(pageNo){
      let url = "/bc/exa/safeBook/selectUserSafeBookPage"
      let {
        theme,
        deptId ,
        fullName ,
        usrName,
        signState
      } =  this.searchFactor
      let dat = {
        student:false,
        deptId ,
        fullName ,
        usrName,
        signState,
        theme,
        pageNo,pageSize : PAGE_SIZE}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.data.length !== 0){
            this.tableData.splice(0)
            response.data.data.data.forEach(t=>{
              this.tableData.push(t)
            })
            this.pager.totalCount = response.data.data.totalDataCount
            this.pager.curPage = pageNo
          }else{
            this.$message({
              showClose: true,
              message: '未查查询到签名信息！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    indexMethod(index){
      return  index + 1
    },
   
    handleCurrentChange(val){
      this.safeBookListLoad(val);
    },
    deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat = {}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.length !== 0){
            this.searchFactor.deptOptions.splice(0)
            this.searchFactor.deptOptions.push({value: "",label: '全部' })
            response.data.data.forEach(t=>{
              this.searchFactor.deptOptions.push({value: t.id,label: t.deptName })
            })
          }else{
            this.$message({
              showClose: true,
              message: '团队列表未查询到数据！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    formatGentle(row, index){
      if(row.gentle == 1){
          return '男';
      }else{
          return '女';
      }
    }

  },
  
  created () {
    setTimeout(()=>{this.deptListLoad(1)},200)
    this.safeBookListLoad(1);
  },
  mounted(){
    
  },
  components: {
    
  }
}
</script>

<style lang="less" scoped>
 
  .item {
  margin-top: 10px;
  margin-right: 15px;
}

.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

.text {
  font-size: 14px;
  color: #000;
}

/deep/.el-progress-bar {


  width : 50%
}
.el-divider--horizontal{
  background-color: #2577d5;
  height: 2px;
  margin: 1px 0 1px 0;
  width: 100%
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_safe_book_search.vue